import * as httpStatus from './smartpak/httpstatus.js';
import * as url from './smartpak/url.js';
import ajaxRequestManager from './views/shared/ajaxrequestmanager.js';
import {bindDatasetListener} from './utils/events.js';
import chat from './smartpak/chat.js';
import client from './api/apiclient.js';
import customerInfo from './controls/customerinfo.js';
import listenForElementWithModalAttributes from './smartpak/lazymodal.js';
import login from './views/customeraccount/login.js';
import manageFirstVisit from './views/shared/managefirstvisit.js';
import modal from './smartpak/modal.js';
import namespace from './smartpak/smartpak.js';
import observeImages from './lazyloadimages.js';
import product from './api/product.js';
import recentlyViewedProducts from './smartpak/recentlyviewedproducts.js';
import recipient from './api/recipient.js';
import rotatingMessageRibbon from './views/shared/ribbon.js';
import searchBox from './views/shared/search.js';
import spree from './views/spree/spree';
import zipcode from './views/shared/zipcode.js';

const api = namespace('api');

api.client = client;
api.product = product;
api.recipient = recipient;
window.smartPak.customerInfo = customerInfo;
window.smartPak.url = url;
window.smartPak.HTTP_STATUS_OK = httpStatus.HTTP_STATUS_OK;
window.smartPak.HTTP_STATUS_CREATED = httpStatus.HTTP_STATUS_CREATED;
window.smartPak.HTTP_STATUS_NOCONTENT = httpStatus.HTTP_STATUS_NOCONTENT;
window.smartPak.HTTP_STATUS_BADREQUEST = httpStatus.HTTP_STATUS_BADREQUEST;
window.smartPak.HTTP_STATUS_UNAUTHORIZED = httpStatus.HTTP_STATUS_UNAUTHORIZED;
window.smartPak.HTTP_STATUS_NOTFOUND = httpStatus.HTTP_STATUS_NOTFOUND;
window.smartPak.HTTP_STATUS_INTERNALSERVERERROR = httpStatus.HTTP_STATUS_INTERNALSERVERERROR;
window.smartPak.HTTP_STATUS_SERVICEUNAVAILABLE = httpStatus.HTTP_STATUS_SERVICEUNAVAILABLE;
window.smartPak.login = login;
window.smartPak.recentlyViewedProducts = recentlyViewedProducts;
window.smartPak.spree = spree;
window.smartPak.zipCode = zipcode;

ajaxRequestManager.init();

namespace('ui').modal = modal;

function onDocReady() {
    customerInfo.init();
    customerInfo.getCustomerInfo().done(response => {
        if (response && response.status === httpStatus.HTTP_STATUS_OK) {
            zipcode.init(response.content.initialUserLocation, smartPak.page.isMobile());
            rotatingMessageRibbon(document.querySelector('#site-ribbon > ul'));
        }
    });

    searchBox();
    observeImages();
    bindDatasetListener();
    manageFirstVisit();
    listenForElementWithModalAttributes();
    login.listenForAuthEvents();
}

if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
    onDocReady();
} else {
    window.addEventListener('DOMContentLoaded', onDocReady);
}

function showUpdateMessageOnLegacyBrowsers() {
    if (/MSIE|Trident/.test(navigator.userAgent)) {
        const $warning = document.getElementById('ieWarning');

        if ($warning) {
            $warning.classList.remove('jsHide');
        }
    }
}

window.addEventListener('load', function () {
    if (smartPak.cdProfileCookie && smartPak.cdProfileCookie.qualifiesForSuggestions) {
        import('./views/smartsuggestion/smartsuggestions.js').then(({default: smartSuggestions}) =>
            smartSuggestions.init()
        );
    }

    document.addEventListener(
        'click',
        function (e) {
            if (/footerEmailBtn/gi.test(e.target.id) || e.target.classList.contains('emailOptIn')) {
                e.preventDefault();

                const loadEmailForm = () => {
                    import('./showemailmodal.js').then(({default: showEmailModal}) => {
                        showEmailModal(e);
                    });
                };

                if (!window.ko) {
                    const script = document.createElement('script');

                    script.async = true;
                    script.type = 'text/javascript';
                    script.onload = loadEmailForm;
                    script.src = '/jsscripts/jquery/knockout/knockout-3.5.1.js';
                    document.getElementsByTagName('head')[0].appendChild(script);
                    return;
                }

                loadEmailForm();
            }
        },
        true
    );

    chat.init();
    prefillUserEmail();

    if (!smartPak.cookie.read('hasSeenCookieNotice')) {
        initiateOnUserAction(() => {
            import('./views/shared/cookienotice.js').then(({default: cookieNotice}) => cookieNotice.init());
        });
    }

    showUpdateMessageOnLegacyBrowsers();

    function initiateOnUserAction(callback, opts = {}) {
        if (typeof callback !== 'function') {
            return;
        }

        const options = {
                autoLoadTimeoutSeconds: 6,
                eventList: ['keydown', 'mousemove', 'wheel', 'touchmove', 'touchstart', 'touchend'],
                ...opts
            },
            triggerScripts = () => {
                callback();
                clearTimeout(autoLoadTimeout);
                options.eventList.forEach(function (event) {
                    window.removeEventListener(event, triggerScripts, {passive: true});
                });
            },
            autoLoadTimeout = setTimeout(triggerScripts, options.autoLoadTimeoutSeconds * 1000);

        options.eventList.forEach(event => window.addEventListener(event, triggerScripts, {passive: true}));
    }

    function prefillUserEmail() {
        const $email = document.getElementById('EmailAddress');

        if ($email && !$email.value && window.sessionStorage) {
            $email.value = sessionStorage.getItem('userEmail') || '';
        }
    }
});
